ValidateShortListedCandidatesModalController.$inject = ["$scope", "modalData", "onSave"];

function ValidateShortListedCandidatesModalController($scope, modalData, onSave) {
    const self = this;

    const init = async () => {
        self.legalMembers = modalData.legalMembers;
        self.brandName = modalData.brandProfile.external_business_name || modalData.brandProfile.name;
        self.illegalMembers = [...modalData.optedOutMembers, ...modalData.blockedFromRehireMembers];
    };

    self.close = () => {
        $scope.$hide();
    };

    self.proceed = () => {
        onSave(self.legalMembers);
        $scope.$hide();
    };

    init();
}

export const getValidateShortListedCandidatesModalController = (modalData, onSave) => {
    return {
        controller: ValidateShortListedCandidatesModalController,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/talent-pool/modals/validate-short-listed-candidates/validate-short-listed-candidates.modal.html',
        show: true,
        backdrop: false,
        resolve: {
            modalData: modalData,
            onSave: onSave
        }
    };
};